module.exports = __webpack_public_path__ + "img/821-7141e7.png";